<div class="page-title">
  <h1>Empresas cadastradas</h1>
  @if(podeCriarEmpresa()) {
    <button matButton="filled" (click)="adicionarEmpresa()">
    <span style="margin-right: 6px; font-size: 16px">+</span> Adicionar
  </button>
  }
</div>

<div class="filtros">
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Nome ou CNPJ</mat-label>
    <input
      matInput
      [(ngModel)]="filtroNome"
      placeholder="Buscar por nome ou CNPJ"
      (keyup)="aplicarFiltro()"
    />
  </mat-form-field>
</div>

<table mat-table [dataSource]="dataSource" class="cis-default-table" matSort>
  <!-- Colunas da tabela (mantidas como antes) -->
  <ng-container matColumnDef="nomeFantasia">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome Fantasia</th>
    <td mat-cell *matCellDef="let empresa">{{ empresa.nomeFantasia }}</td>
  </ng-container>

  <ng-container matColumnDef="cnpj">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>CNPJ</th>
    <td mat-cell *matCellDef="let empresa">{{ formatarCnpjLocal(empresa.cnpj) }}</td>
  </ng-container>

  <ng-container matColumnDef="estado">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
    <td mat-cell *matCellDef="let empresa">{{ empresa.estado }}</td>
  </ng-container>

  <ng-container matColumnDef="cidade">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Cidade</th>
    <td mat-cell *matCellDef="let empresa">{{ empresa.cidade }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header"></tr>
  <tr mat-row (click)="abrirDetalhesEmpresa(row.id)" *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<div class="paginator-container">
  <p class="contagem-texto">{{ textoContagem }}</p>
  <mat-paginator
    [length]="total"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
    [showFirstLastButtons]="false"
    [selectConfig]="{ disableOptionCentering: true, panelClass: 'custom-paginator-select' }"
    aria-label="Selecionar página de resultados"
  >
  </mat-paginator>
</div>
